import Footer from '../../../../components/Footer';

const FooterSection = () => {
  return <Footer paddingLeft={80} paddingRight={80} paddingTop={140} />;
};

export default FooterSection;
